<template>
  <v-container>
    <v-col cols="12">
      <PublicBanner text="شرایط صدور گواهی" />
      <PublicList
        header_icon="mdi-alert-circle-check-outline"
        :nested_items="conditions"
        text_icon="''"
      />
      <br />
      <PublicBanner text="توضیحات" />
      <PublicList :index_items="description" />
      <br />
      <PublicBanner text="کاربرد گواهینامه معادل" />
      <PublicList :index_items="usage" text_icon="mdi-check-outline" />
      <h4 class="text-center">با ما همراه باشید</h4>
    </v-col>
  </v-container>
</template>

<script>
import PublicBanner from "@/packages/public/components/PublicBanner";
import PublicList from "@/packages/public/components/PublicList";
export default {
  name: "Condition",
  components: { PublicList, PublicBanner },
  data() {
    return {
      conditions: [
        {
          header: "شرایط اخذ مدرک معادل دیپلم",
          titles: [
            "–داشتن مدرک سوم راهنمایی یا معادل و داشتن یک سال سابقه کار مرتبط",
          ],
        },
        { divider: true },
        {
          header: "شرایط اخذ مدرک کاردانی (فوق دیپلم)",
          titles: ["–داشتن دیپلم و معادل آن و یک سال سابقه کار مرتبط"],
        },
        { divider: true },
        {
          header: "شرایط اخذ مدرک کارشناسی (لیسانس)",
          titles: ["–داشتن فوق دیپلم و معادل آن و ۲ سال سابقه کار مرتبط"],
        },
        { divider: true },
        {
          header: "شرایط اخذ مدرک کارشناسی ارشد (فوق لیسانس)",
          titles: ["–داشتن لیسانس و معادل آن و ۳ سال سابقه کار مرتبط"],
        },
        { divider: true },
        {
          header: "شرایط اخذ مدرک دکترا",
          titles: ["–داشتن فوق لیسانس و معادل آن و ۵ سال سابقه کار مرتبط"],
        },
        { divider: true },
        {
          header: "شرایط صدور گواهی تکنسین و کاردان",
          titles: [
            "– داشتن دوره آموزشی ۸۰۰ ساعت در رشته مرتبط فنی",
            "– داشتن حداقل ۵ سال سابقه کار در رشته مرتبط فنی",
            "– ارائه مقاله ترویجی در رشته مرتبط فنی",
          ],
        },
        { divider: true },
        {
          header: "شرایط صدور گواهی متخصص و کارشناس",
          titles: [
            "– داشتن ۱۶۰۰ ساعت دوره آموزشی در رشته مرتبط فنی",
            "– داشتن حداقل ۱۰ سال سابقه کار در رشته مرتبط فنی",
            "– ارائه مقاله تخصصی در رشته مرتبط فنی",
          ],
        },
        { divider: true },
      ],
      description: [
        {
          text: "گواهی صادره به هیچ عنوان ارزش تحصیلی یا دانشگاهی ندارد.",
        },
        {
          text: "گواهی صادره صرفا و بنا به درخواست متقاضی تعیین سطح و صادر گردیده است.",
        },
        {
          text: "گواهی صادره بدلیل اینکه بار علمی ندارد به همین خاطر به هیچ وجه امکان ادامه تحصیل با این گواهی مقدور نمی باشد.",
        },
        {
          text: "گواهی صادره از روی سوابق علمی و شغلی تعیین سطح گردیده و متقاضی هیچ گونه دوره ای ندیده و نیز آزمونی ارایه نداده است.",
        },
        {
          text: "گواهی صادره به هیچ عنوان تحت هیچ شرایطی مورد تایید وزارتخانه های (علوم، بهداشت، ارشاد، آموزش و پرورش) و دانشگاهها، موسسات آموزش عالی، سازمان فنی و حرفه ای نمی باشد.",
        },
        {
          text: "گواهی صادره به هیچ عنوان مدرک تحصیلی و دانشگاهی محسوب نشده و این گواهی به منزله پروانه یا مجوز فعالیت تلقی نگردیده و در مواردی همچون استخدام و ارتقاءشغلی و افزایش حقوق در مراکز دولتی و نیمه دولتی در صورت پذیرش مدیریت آن مجموعه مورد قبول می باشد.",
        },
      ],
      usage: [
        { text: "ثبت شرکت در برخی موارد" },
        { text: "مهاجرت به برخی کشور ها" },
        { text: "اخذ پروانه کسب از برخی اتحادیه ها" },
        { text: "استخدام در شرکتها و کارخانه جات خصوصی" },
        { text: "افزایش حقوق وارتقا شغلی در برخی ادارات و مراکزخصوصی" },
        { text: "بالا بردن وجهه اجتماعی وپر کردن رزومه کاری" },
        { text: "ایجاد اشتغال و راه اندازی" },
      ],
    };
  },
};
</script>

<style scoped>
h3 {
  margin-bottom: 1rem;
  font-size: 20px;
}
p {
  font-weight: bold;
  font-size: 18px;
}
</style>
